@if (bannerNode | async ; as item) {
  <div class="main_inner-wrapper">
    <div class="home_container container col-xs-12" id="landingHome" [ngClass]="{'home_container-uk':item.uid=='seqirus-overviewuk-hero-component'}">
      <div class="d-none overview_us_breadcrumbs">
        <p><a routerLink="/">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span><a routerLink="/overview"><strong>{{"statictext.flu360" | cxTranslate}}<sup>®</sup>
      {{"statictext.overview" | cxTranslate}}</strong></a></p>
    </div>
    <section class="col-xs-12 home_loginsectionUS" [ngClass]="{'home_loginsection-uk':currentSite=='seqirusb2b-uk'}" id="home_loginsection" style="background-image:url('{{getImage(item.media)}}');">
      <!--  <div class="simple-banner banner__component--responsive" *ngIf="item?.media">
      <img class="js-responsive-image" [ngClass]="{'banner1':currentSite=='seqirusb2b-uk'}" [attr.alt]="item?.media.altText"
        [attr.title]="item?.media.altText" [src]="getImage(item.media)">
      </div> -->
      <div class="col-xs-12 home_topfirst home_stretch">
        <!-- <div *ngIf="item.uid !='seqirus-overview-hero-component' && item.uid !='seqirus-overviewuk-hero-component' && !productpage"
        class="homepagemobuserguideparent col-xs-12 col-md-12  d-md-block d-lg-none d-block d-sm-none">
        <app-help-widget></app-help-widget>
      </div> -->
      @if (item.uid !='seqirus-overview-hero-component' && item.uid!='seqirus-overviewuk-hero-component') {
        <div class="col-xs-12 col-md-6 col-lg-7" id="home_loginleftsection"
          >
          <div id="home_leftcontent">
            <div id="home_leftheader" class="modified-h1">
              <div class="global_Lshape">
                <div class="global_horizontalL"></div>
                <div class="global_verticalL"></div>
              </div>
              <div class="allproducts_heading" [innerHTML]="item.headline"></div>
            </div>
            <div id="home_leftcontenttext" [innerHTML]="item.largeparagraphcontent"></div>
            <div class="home_tivbtn" id="home_leftoverviewbtn" [innerHTML]="item.content" appRouterlinkinterceptor></div>
            <div id="home_leftoverviewtext"></div>
          </div>
        </div>
      }
      @if (item.uid =='seqirus-overview-hero-component' || item.uid=='seqirus-overviewuk-hero-component') {
        <div class="col-xs-12 col-md-6 col-lg-7"
          id="overView_loginleftsection">
          <div id="home_leftcontent" [ngClass]="{'home_leftcontent-uk':item.uid=='seqirus-overviewuk-hero-component'}">
            <div class="breadcrumbs-opeff overViewCrumbs"[ngClass]="{'overViewCrumbs-uk':item.uid=='seqirus-overviewuk-hero-component'}">
              <p><a routerLink="/">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span><a routerLink="/overview"><strong>{{"statictext.flu360" | cxTranslate}}@if (item.uid!='seqirus-overviewuk-hero-component') {
              <sup>®</sup>
            }
          {{"statictext.overview" | cxTranslate}}</strong></a></p>
        </div>
        <h1 id="home_leftheader" class="modified-h1">
          <div class="global_Lshape">
            <div class="global_horizontalL"></div>
            <div class="global_verticalL"></div>
          </div>
          <div class="allproducts_heading-overView" [innerHTML]="item.headline"></div>
        </h1>
        <div id="home_leftcontenttext">{{item.h2content}}</div>
        @if (item.
          largeparagraphcontent
          ) {
          <div id="home_leftcontenttext">{{item.largeparagraphcontent}}</div>
        }
        <div class="overView_tivbtn" id="overView_leftoverviewbtn" [innerHTML]="item.content" appRouterlinkinterceptor></div>
        <div id="home_leftoverviewtext"></div>
      </div>
    </div>
  }
  <!-- <div class="col-md-6 col-lg-5 d-none d-sm-block d-md-none d-lg-block " id="home_loginrightsection">
  <div id="home_rightcontent">
    <div *ngIf="item.uid !='seqirus-overview-hero-component' && item.uid !='seqirus-overviewuk-hero-component' && !productpage" class="homepageuserguideparent">
      <app-help-widget></app-help-widget>
    </div>
  </div>
</div> -->
</div>
</section>
<!-- for overview page mobile view-->
<div class="col-xs-12 col-md-6 col-lg-7 d-none" id="mobile_overView_loginleftsection">
  <div id="mobile_home_leftcontent" [ngClass]="{'home_leftcontent-uk':item.uid=='seqirus-overviewuk-hero-component'}">
    <div class="breadcrumbs-opeff overViewCrumbs" [ngClass]="{'overViewCrumbs-uk':item.uid=='seqirus-overviewuk-hero-component'}">
      <p><a routerLink="/">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span><a routerLink="/overview"><strong>{{"statictext.flu360" | cxTranslate}}@if (item.uid!='seqirus-overviewuk-hero-component') {
      <sup>®</sup>
    }{{"statictext.overview" | cxTranslate}}</strong></a></p>
  </div>
  <h1 id="home_leftheader" class="modified-h1">
    <div class="global_Lshape">
      <div class="global_horizontalL"></div>
      <div class="global_verticalL"></div>
    </div>
    <div class="allproducts_heading-overView" [innerHTML]="item.headline"></div>
  </h1>
  <div id="home_leftcontenttext">{{item.h2content}}</div>
  @if (item.largeparagraphcontent) {
    <div id="home_leftcontenttext">{{item.largeparagraphcontent}}</div>
  }
  <div class="overView_tivbtn" id="overView_leftoverviewbtn" [innerHTML]="item.content" appRouterlinkinterceptor></div>
  <div id="home_leftoverviewtext"></div>
</div>
</div>
</div>
</div>
}

<!--FOR ALL PRODUCTS-->
@if (productpage) {
@if (bannerNode | async ; as item) {
@if (item.uid === "seqirus-lin-UKproduct-hero-component"){
<section class="ukallprod_Banner" id="ukallprod_Banner">
  <div id="allprodbannner_container" class="allprodbannner_container">
    <div class="allprodbanner_image">
      <picture>
        <source [srcset]="getImage(item.media.widescreen)" media="(min-width: 1700px)">
        <source [srcset]="getImage(item.media.tablet)" media="(min-width: 1024px) and (max-width:1399px)">
        <img class="allprod_flu-vaccine" alt="Flu vaccine creation" [src]="getImage(item.media.desktop)">
      </picture>
    </div>
    <div class=" allprodbannercontent">
      <div class="allprodbannerheader">
        <img class="rectangle-down" src="../../../app/../assets/images/rectangle-down.svg">
        <p class="headLine" [innerHTML]="item.headline"></p>
      </div>
    </div>
  </div>
</section>
}
@else{
  <div class="all-produts-main_inner-wrapper d-none">
  @if (item?.media) {
  <div class="hero--grad" role="img" alt="Scientist with microscope" aria-label="Scientist with microscope"
    [style.backgroundImage]="'url(' + getImage(item.media) + ')'">
    <!--breadcrumbs-->
    @if (!userLoggedIn) {
    <div class="breadcrumbs--page-nav">
      <div class="container">
        <p><a [routerLink]="'/'">{{"statictext.home" | cxTranslate}}</a><span> &gt;
          </span><strong>{{"statictext.products" | cxTranslate}}</strong></p>
      </div>
    </div>
    }
    <div class="row-flex">
      <div class="col-flex-12 hidden-sm hidden-md hidden-lg hero--grad__mobile">
        <img alt="Scientist with microscope" [src]="getImage(item.media)" role="presentation">
      </div>
      <div class="container">
        <div class="col-12 col-md-8">
          @if (!userLoggedIn) {
          <div class="hero--grad__content LO-hero--grad__content">
            <div class="content-container content-container--has-corner text-left">
              <h1 [innerHTML]="item.headline"></h1>
              <p class="text--grey-100">{{item.h2content}}</p>
            </div>
          </div>
          }
          @if (userLoggedIn) {
          <div class="hero--grad__content LI-hero--grad__content">
            <div class="content-container content-container--has-corner text-left">
              <h1 [innerHTML]="item.headline"></h1>
              <p class="text--grey-100">{{item.h2content}}</p>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  }
</div>

}
}
}


<!-- <form [formGroup]="myForm" (ngSubmit)="onClick()">
  <div>
    <label>
      password:
      <input formControlName="password" placeholder="Your name">
    </label>
  </div>
  <div>
    <label>
      Email:
      <input formControlName="email" placeholder="Your email">
    </label>
  </div>
  <button type="submit">Send</button>
</form> -->


<!-- <div class="productsmobile d-none">
<div class="simple-banner banner__component--responsive">
  <img class="js-responsive-image" alt="Healthcare professional silhouette"
    title="Healthcare professional silhouette" [src]="getImage(item.media)">
  </div>
  <div class="container products-mobile-content col-md-8">
    <h1 id="home_leftheader" class="modified-h1">
      <div class="global_Lshape">
        <div class="global_horizontalL"></div>
        <div class="global_verticalL"></div>
      </div>
      <div class="allproducts_heading" [innerHTML]="item.headline"></div>
    </h1>
    <div id="home_leftcontenttext">{{item.h2content}}</div>
    <div id="home_leftoverviewtext"></div>
  </div>
</div> -->

<!-- <div class="container" *ngIf="!userLoggedIn">
<p class="breadcrumbs-for-products d-none"><a href="/">Home</a><span> &gt; </span><strong>Products</strong>
</p>
</div> -->